<script setup lang="ts">
import ProductAvailability from '~/components/product/ProductAvailability.vue'

interface Props {
  supplierImgSrc?: string
  supplierName: string
  availabilityStatus: string
  availabilityBestBefore?: string
  reAvailabilityDate?: string
  lastOrderedQuantity: number
}
const props = withDefaults(defineProps<Props>(), {
  supplierImgSrc: '',
})
const emits = defineEmits<{
  orderOptimizationHandler: [event: Event]
}>()
const { $moment } = useNuxtApp()
function orderOptimizationHandler(event: Event) {
  emits('orderOptimizationHandler', event)
}
const localePath = useLocalePath()

const isBestBeforeInFuture = computed(() =>
  props.availabilityBestBefore
    ? $moment(props.availabilityBestBefore).isSameOrAfter($moment(), 'day')
    : false,
)
</script>

<template>
  <NuxtLink class="text-decoration-none" data-nav-id="product_supplier_image" :to="localePath(`/supplier/${supplierName}`)">
    <NuxtImg
      :src="props.supplierImgSrc ? props.supplierImgSrc : 'https://placehold.co/20x10?text=No+image'"
      width="40"
      height="50"
    />
  </NuxtLink>
  <div class="px-3">
    <ProductAvailability
      :availability-status="props.availabilityStatus"
      :re-availability-date="props.reAvailabilityDate"
      data-test-id="product-availabilityStatus"
    />
    <p v-if="isBestBeforeInFuture" data-test-id="product-bestBefore" class="text-caption text-vm-grey-7 ma-0">
      {{
        $t('product.bestBefore', {
          date: $moment(props.availabilityBestBefore).format($t('date.format')),
        })
      }}
    </p>
  </div>
  <v-btn
    v-if="Boolean(props.lastOrderedQuantity)"
    data-test-id="product-order-optimizationBtn"
    icon="veticon-bar-chart"
    variant="text"
    class="ml-auto"
    height="40"
    data-track-id="product_open_order_optimization"
    @click="orderOptimizationHandler"
  />
</template>

<style scoped lang="scss">
.vmz-product-info {
  &__third-col {
    height: 40px
}
}
</style>
